const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");
// (a technology the New Wonders and Leaders expansion changed takes its version: 'expansion', else the base game's; see
// Constants/CardVersions.js)
const IsExpansion = (version) => version === 'expansion';

class Government extends Technology {
    constructor(age, techName, scienceCost, revolutionCost, civilActions, militaryActions, urbanBuildingLimit, extraEffects = () => {}){
        super(
            age,
            Government.GetType(),
            techName,
            scienceCost,
            null,
            {
                playerStateAltering:
                (playerState) => {
                    playerState.civilActionCalculationDelegate.push({
                        Source: this,
                        Action: () => civilActions,
                    });
                    playerState.militaryActionCalculationDelegate.push({
                        Source: this,
                        Action: () => militaryActions,
                    });
                    playerState.urbanBuildingLimitCalculationDelegate.push({
                        Source: this,
                        Action: () => urbanBuildingLimit,
                    })
                    extraEffects(playerState);
                }
            }
        );
        this.revolutionCost = revolutionCost;
        // (as printed on the card)
        this.civilActions = civilActions;
        this.militaryActions = militaryActions;
        this.urbanBuildingLimit = urbanBuildingLimit;
    }
    static GetType = () => TechnologyTypes.Government;
}

class Despotism extends Government {
    constructor(){
        super(Despotism.GetAge(), Despotism.GetName(), 0, 0, 4, 2, 2)
    }

    static GetInstance = () => new Despotism();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Government.Despotism;
}

class Monarchy extends Government {
    constructor(){
        super(Monarchy.GetAge(), Monarchy.GetName(), 8, 2, 5, 3, 3)
    }

    static GetInstance = () => new Monarchy();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Government.Monarchy;
}

class Theocracy extends Government {
    constructor(){
        super(Theocracy.GetAge(), Theocracy.GetName(), 6, 1, 4, 3, 3, 
            (playerState) => {
                playerState.cultureProductionCalculationDelegate.push({
                    Source:this,
                    Action: () => 1,
                });
                playerState.militaryCalculationDelegate.push({
                    Source:this,
                    Action: () => 1,
                });
                playerState.happyFaceCalculationDelegate.push({
                    Source:this,
                    Action: () => 1,
                });
            })
    }

    static GetInstance = () => new Theocracy();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Government.Theocracy;
}

// (the expansion's: 11 science, revolution 2; the base game's: 13, 3)
class Republic extends Government {
    constructor(version){
        super(Republic.GetAge(), Republic.GetName(), IsExpansion(version) ? 11 : 13, IsExpansion(version) ? 2 : 3, 7, 2, 3)
        this.version = version;
    }

    static GetInstance = (version) => new Republic(version);
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Government.Republic;
}

class ConstitutionalMonarchy extends Government {
    constructor(){
        super(ConstitutionalMonarchy.GetAge(), ConstitutionalMonarchy.GetName(), 12, 6, 6, 4, 3)
    }

    static GetInstance = () => new ConstitutionalMonarchy();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Government.ConstitutionalMonarchy;
}

// (the expansion's: 18 science, revolution 1, and +1 resource; the base game's: 19, 5, no resource)
class Communism extends Government {
    constructor(version){
        super(Communism.GetAge(), Communism.GetName(), IsExpansion(version) ? 18 : 19, IsExpansion(version) ? 1 : 5, 7, 5, 4,
            (playerState) => {
                playerState.happyFaceCalculationDelegate.push({
                    Source:this,
                    Action: () => -1,
                });
                // (a production bonus: produced with the others, see PlayerState.ProduceBonus)
                if (IsExpansion(version))
                {
                    playerState.resourceProductionCalculationDelegate.push({
                        Source:this,
                        Action: () => 1,
                    });
                }
            })
        this.version = version;
    }

    static GetInstance = (version) => new Communism(version);
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Government.Communism;
}

// (the expansion's: 16 science, revolution 5, +6 strength; the base game's: 18, 7, +5)
class Fundamentalism extends Government {
    constructor(version){
        super(Fundamentalism.GetAge(), Fundamentalism.GetName(), IsExpansion(version) ? 16 : 18, IsExpansion(version) ? 5 : 7, 7, 5, 4,
            (playerState) => {
                playerState.scienceProductionCalculationDelegate.push({
                    Source: this,
                    Action: () => -2,
                });
                playerState.militaryCalculationDelegate.push({
                    Source: this,
                    Action: () => IsExpansion(version) ? 6 : 5,
                });
            })
        this.version = version;
    }

    static GetInstance = (version) => new Fundamentalism(version);
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Government.Fundamentalism;
}

class Democracy extends Government {
    constructor(){
        super(Democracy.GetAge(), Democracy.GetName(), 17,9,7,3,4,
            (playerState) => {
                playerState.cultureProductionCalculationDelegate.push({
                    Source: this,
                    Action: () => 3,
                });
            })
    }

    static GetInstance = () => new Democracy();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Government.Democracy;
}

module.exports = {
    Despotism,
    Monarchy,
    Theocracy,
    Republic,
    ConstitutionalMonarchy,
    Communism,
    Fundamentalism,
    Democracy
}